import React from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Coffee } from "lucide-react";

export default function Login() {
  const { t, isRTL } = useI18n();
  const serifClass = isRTL ? "font-serif-ar" : "font-serif-en";
  const location = useLocation();

  const handleLogin = () => {
    // Preserve where the user was trying to go (?next=/academy etc.) across the OAuth round trip
    const next = new URLSearchParams(location.search).get("next");
    if (next) {
      try { sessionStorage.setItem("auth_next", next); } catch (_) { /* ignore */ }
    }
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="max-w-md mx-auto px-6 pt-24 pb-24" data-testid="login-page">
      <div className="soft-card rounded-2xl p-10 text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-[#C86240] flex items-center justify-center mb-6">
          <Coffee className="w-6 h-6 text-white" />
        </div>
        <h1 className={`${serifClass} text-3xl text-[#2A2421] leading-tight`}>{t.auth.title}</h1>
        <p className="mt-3 text-[#5C544F] leading-relaxed">{t.auth.lead}</p>
        <Button
          onClick={handleLogin}
          data-testid="google-login-btn"
          className="mt-8 w-full h-12 rounded-xl bg-[#2A2421] hover:bg-[#2A2421]/90 text-[#F9F6F0]"
        >
          {t.auth.google}
        </Button>
      </div>
    </div>
  );
}
